module.exports = __webpack_public_path__ + "img/UAV_auto2.fb9f6690.png";